import styled, { useTheme } from 'styled-components';
import TokenSelector from '../Inputs/TokenSelect';
import { useDispatch, useSelector } from 'react-redux';
import { openModal } from '../../redux/slices/modals';
import { selectCardImage } from '../../redux/slices/customizeCard'; // Select customizeCard state
import { ParagraphLargeText, ParagraphSmallText } from '../Texts';
import { fromTokenAmount } from '../../hooks/useSolana';
import { selectTokenByNetworkAndAddress } from '../../redux/slices/tokenSlice';

const CardContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: calc(100% * 226 / 407); /* Aspect ratio for Card */
  background-color: ${({ theme }) => theme.background.primary};
  border-radius: 16px;
  box-shadow: 0 4px 6px ${({ theme }) => theme.special.shadow};

  background-image: ${({ $background }) =>
    $background ? `url(${$background})` : 'none'};
  background-size: cover;
  background-position: center;
`;

const TokenDetailsContainer = styled.div`
  border-radius: 16px;
  position: absolute;
  bottom: 15px;
  left: 15px;
  right: 15px;
  display: flex;
  padding: 12px;
  background-color: rgba(241, 241, 241, 0.88);
  gap: 2px;
  align-items: center;
`;

const TokenBalanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
`;

const CustomizeButton = styled.div`
  position: absolute;
  right: 15px;
  top: 15px;
  background-color: ${({ theme }) => theme.background.light};
  padding: 5px 10px;
  border-radius: 16px;
  font-weight: 500;
  font-size: 12px;
  color: ${({ theme }) => theme.text.regular};
`;

const Card = ({ handleSelectionChange, card }) => {
  const dispatch = useDispatch();
  const background = useSelector(selectCardImage);

  const aspectRatio = 226 / 407;

  const cardWidth = 450;
  const cardHeight = cardWidth * aspectRatio;

  const cardSize = {
    width: cardWidth,
    height: cardHeight,
  };

  const tokenDetails = useSelector((state) =>
    selectTokenByNetworkAndAddress(state, card?.network, card?.token),
  );

  const formattedAmount = fromTokenAmount(
    parseFloat(card.tokenAmount),
    tokenDetails?.decimals,
  );

  const theme = useTheme();

  return (
    <CardContainer $background={card?.imageUrl || background}>
      {card ? (
        <TokenDetailsContainer>
          <TokenBalanceContainer>
            <ParagraphSmallText $color={theme.text.secondary}>
              Balance
            </ParagraphSmallText>
            <div style={{ display: 'flex' }}>
              <ParagraphLargeText>
                {formattedAmount} {card.symbol}
                {tokenDetails?.name}
              </ParagraphLargeText>
              <ParagraphLargeText $color={theme.text.secondary}>
                &nbsp;({tokenDetails?.symbol})
              </ParagraphLargeText>
            </div>
          </TokenBalanceContainer>

          <img src={tokenDetails?.logoURI} style={{ width: 40, height: 40 }} />
        </TokenDetailsContainer>
      ) : (
        <>
          <CustomizeButton
            onClick={() =>
              dispatch(
                openModal({ name: 'customizeCard', props: { cardSize } }),
              )
            }
          >
            Customize
          </CustomizeButton>
          <TokenDetailsContainer>
            <TokenSelector onSelectionChange={handleSelectionChange} />
          </TokenDetailsContainer>
        </>
      )}
    </CardContainer>
  );
};

export default Card;
